export default __webpack_public_path__ + "static/media/dlback_res.d45baae5.jpg";